import { render, staticRenderFns } from "./Pnab.vue?vue&type=template&id=7c07c6f0&"
import script from "./Pnab.vue?vue&type=script&lang=js&"
export * from "./Pnab.vue?vue&type=script&lang=js&"
import style0 from "./Pnab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports